import React, { PureComponent } from "react";

import {
  Scroll,
  Wrapper,
  CardBody,
  Stretch,
  CenterCenter,
  Button,
  Row,
  Icon,
  Title
} from "app/NativeComponents/common";

const Masonry = require("react-masonry-component");

class List extends PureComponent {
  componentDidMount(prevProps) {
    var elem = document.getElementById("activity_list");
    if (elem) {
      elem.scrollTop = elem.height;
    }
  }

  renderHeader(listHeader) {
    if (listHeader) {
      return listHeader();
    }
  }
  renderFooter(listFooter) {
    if (listFooter) {
      return listFooter();
    }
  }
  renderLoadMore(canLoadMore, onLoadMore, isLoadingMore, infiniteScroll) {
    if (infiniteScroll) {
      if (isLoadingMore) {
        return (
          <CardBody>
            <Stretch>
              <Button onPress={onLoadMore}>
                <Row
                  style={{
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i
                    class="fa fa-spinner fa-spin"
                    size={26}
                    style={{
                      marginRight: 10
                    }}
                  ></i>
                  <Title>Loading</Title>
                </Row>
              </Button>
            </Stretch>
          </CardBody>
        );
      } else if (canLoadMore && !isLoadingMore) {
        return (
          <CardBody>
            <Stretch>
              <Button onPress={onLoadMore}>
                <Row
                  style={{
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Icon
                    size={26}
                    icon={"refresh"}
                    style={{
                      marginRight: 10
                    }}
                  />
                  <Title>Load More</Title>
                </Row>
              </Button>
            </Stretch>
          </CardBody>
        );
      }

      return <Wrapper />;
    }
  }

  render() {
    const {
      style,
      items,
      infiniteScroll,
      rowNumber,
      itemStruture,
      canRefresh,
      onRefresh,
      is_refreshing,
      canLoadMore,
      onLoadMore,
      isLoadingMore,
      listHeader,
      listFooter,
      invertedScroll,
      scrollView = false,
      scroll_ref = null,
      id
    } = this.props;
    if (rowNumber > 1) {
      return (
        <Scroll
          id={id}
          scroll_ref={scroll_ref}
          style={scrollView ? { ...style, flex: 1 } : { style }}
        >
          {this.renderHeader(listHeader)}
          <Masonry
            className={"dm-list dm-list-" + rowNumber} // default ''
            elementType={"div"} // default 'div'
            style={{
              maxWidth: 800,
              margin: "0px auto"
            }}
            options={{
              transitionDuration: 0
            }} // default {}
            disableImagesLoaded={false} // default false
            updateOnEachImageLoad={true} // default false and works only if disableImagesLoaded is false
          >
            {invertedScroll
              ? items
                  .slice(0)
                  .reverse()
                  .map((item, index) => {
                    return itemStruture({ item, index });
                  })
              : items.map((item, index) => {
                  return itemStruture({ item, index });
                })}
          </Masonry>
          {this.renderLoadMore(
            canLoadMore,
            onLoadMore,
            isLoadingMore,
            infiniteScroll
          )}
          {this.renderFooter(listFooter)}
        </Scroll>
      );
    }

    return (
      <Scroll
        id={id}
        scroll_ref={scroll_ref}
        style={scrollView ? { ...style, flex: 1 } : { style }}
      >
        {this.renderHeader(listHeader)}
        {invertedScroll
          ? items
              .slice(0)
              .reverse()
              .map((item, index) => {
                return itemStruture({ item, index });
              })
          : items.map((item, index) => {
              return itemStruture({ item, index });
            })}
        {this.renderLoadMore(
          canLoadMore,
          onLoadMore,
          isLoadingMore,
          infiniteScroll
        )}
        {this.renderFooter(listFooter)}
      </Scroll>
    );
  }
}

export { List };
